import type { Locale } from "@/i18n";

interface AboutCopy {
  sectionLabel: string;
  founderImageAlt: string;
  founderCaption: string;
  studioLine: string;
  foundedByLine: string;
  founderBio: string;
  personalNote: string;
}

const en: AboutCopy = {
  sectionLabel: "The Studio",
  founderImageAlt: "Zsolt Molnar",
  founderCaption: "Zsolt Molnar · Founder",
  studioLine:
    "Garlic Tech is a small Budapest-based studio. Our most recent projects were all built end to end on our AI-supported workflows, in weeks rather than months, and are in daily use today: you will find them in the list above. The field moves month to month, so we watch what comes out and fold in what proves itself: we follow what actually works, not the hype. Every project ends with a documented handoff: the code and the knowledge stay with you, so continuity never depends on us.",
  foundedByLine: "Founded by Zsolt Molnár",
  founderBio:
    "Zsolt has spent more than 20 years across research labs, startups, and enterprise platforms: file-transfer systems that supported the Higgs boson discovery at CERN, a deep-space telemetry tool built for ESA with McKinsey in three weeks, and over a decade of consulting for McKinsey, General Electric, Nokia, Morgan Stanley, and enterprise teams across Europe. Today his focus is practical AI: agentic systems, LLM integrations, and AI-supported workflows that keep senior judgment in the loop.",
  personalNote:
    "Outside engineering, he lives in one of the greener parts of Budapest and spends much of his free time on long hikes. A few years ago he completed the 800 km El Camino pilgrimage, an experience that shaped how he approaches focus, endurance, and independent work.",
};

const hu: AboutCopy = {
  sectionLabel: "A stúdió",
  founderImageAlt: "Molnár Zsolt",
  founderCaption: "Molnár Zsolt · alapító",
  studioLine:
    "A Garlic Tech egy kis budapesti stúdió. A szakma hónapról hónapra változik, ezért figyeljük, mi jön ki, és ami beválik, azt beépítjük a munkánkba: nem a hype-ot követjük, hanem azt, ami tényleg működik. Minden projektet dokumentált átadással zárunk, a kód és a tudás nálad marad, így a folytatás nem függ tőlünk.",
  foundedByLine: "Alapító: Molnár Zsolt",
  founderBio:
    "Molnár Zsolt húsz éve dolgozik kutatóintézetek, startupok és nagyvállalati rendszerek világában. Fájlátviteli rendszereket írt, amelyek a CERN-ben a Higgs-bozon felfedezését segítették, a McKinsey-vel az ESA-nak három hét alatt épített mélyűri telemetriai eszközt, és több mint egy évtizedig tanácsadóként dolgozott a McKinsey, a General Electric, a Nokia és a Morgan Stanley projektjein. Ma a gyakorlati AI-ra koncentrál: ágens-rendszerek, LLM-integrációk és AI-alapú munkafolyamatok, amelyekben a szenior szakmai kontroll végig a folyamatban marad.",
  personalNote:
    "A munkán kívül Budapest egyik zöldebb részén él, és a szabadidejét nagyrészt hosszú túrákon tölti. Néhány éve végigjárta a 800 kilométeres El Caminót. Az ilyen út megtanítja, mit jelent egyedül végigvinni valamit, és mikor kell inkább megállni egy napra.",
};

export const ABOUT_COPY: Record<Locale, AboutCopy> = {
  en,
  hu,
};
